import React from "react"
import { formatDateRange, formatHoursAndDates } from "src/functions/dateFormats"
import { addUTMSource } from "src/functions/linksFormat"

const country = {
    "1": {
        flag: "https://cdn4.fincaraiz.com.co/web/650cb8979c579_banderas-(1).png" //Uruguay
    },
    "2": {
        flag: "https://cdn4.fincaraiz.com.co/web/6514dd6903792_banderas-(2).png" //Paraguay
    },
    "3": {
        flag: "https://cdn4.fincaraiz.com.co/web/6514dcc28c91a_banderas-(4).png" //Argentina
    },
    "4": {
        flag: "https://cdn4.fincaraiz.com.co/web/6514dcc28d950_banderas-(3).png" //Chile
    },
    "5": {
        flag: "https://cdn4.fincaraiz.com.co/web/65146f135702d_banderas-bolivia.png" //Bolivia
    },
    "6": {
        flag: "https://cdn4.fincaraiz.com.co/web/66a2b00f0770b_banderas-04.png" //Colombia
    },
    "7": {
        flag: "https://cdn4.fincaraiz.com.co/web/66a2b02769cca_banderas-03.png" //Perú
    },
    "8": {
        flag: "https://cdn4.fincaraiz.com.co/web/66a2b00ecce4f_banderas-01.png" //Costa Rica
    },
    "9": {
        flag: "https://cdn4.fincaraiz.com.co/web/66a2b00f0ad6e_banderas-02.png" //Panamá
    }
}

export const EventItem = ({ data }) => {
    const currentCountry = country[data.countryId]
    const dateFormatted = formatDateRange(data.startDate, data.endDate)
    const hourFormatted = formatHoursAndDates(data.startHour, data.endHour, data.startDate, data.endDate)
    const linkFormatted = data.link !== "" ? addUTMSource(data.link) : ""

    return (
        <div className="event-item">
            <div className="event-item-first">
                <img src={data.image !== "" ? data.image : "https://cdn4.fincaraiz.com.co/web/651d9700db901_default-image.png"} className="event-item-first-image" />

                <div className="event-item-first-content">
                    <span className="event-item-first-content-title">
                        {currentCountry && <img src={currentCountry?.flag} className="event-item-first-content-title-flag" />}
                        <span>{data.name}</span>
                    </span>
                    <p className="event-item-first-content-description">
                        {data.description}
                    </p>
                    <div className="event-item-first-content-info">
                        <span>
                            <img src="https://cdn4.fincaraiz.com.co/web/650122539a936_recurso-3@2x.png" />
                            {hourFormatted}
                        </span>
                        <span>
                            <img src="https://cdn4.fincaraiz.com.co/web/65012250d743f_recurso-2@2x.png" />
                            {data.location}
                        </span>
                    </div>
                </div>

                <div className="event-item-first-date">
                    <span className="days-container">
                        {dateFormatted.days.map((day, index) => (
                            <span key={`item-date-${index}`} className="small-text-container">
                                {dateFormatted.days.length > 1 ? index === 0 ? <span className="small-text">Desde</span> : <span className="small-text">Hasta</span> : ""}
                                <span>{day}</span>
                            </span>
                        ))}
                    </span>
                    <span className="months-container">
                        {dateFormatted.months.map((month, index) => (
                            <React.Fragment key={`month-item-${index}`}>
                                <span>{month.toLocaleUpperCase()}</span>
                            </React.Fragment>
                        ))}
                    </span>
                </div>
            </div>

            <div className="event-item-first-content-separator"></div>

            <div className="event-item-container">
                <a href={linkFormatted} target="_blank" className="event-item-container-cta">
                    AGENDARME
                </a>
            </div>
        </div>
    )
}